import React from 'react';
import { useRouteError, isRouteErrorResponse } from 'react-router';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export function RootErrorBoundary(): React.ReactNode {
  const error = useRouteError();
  const isRoute = isRouteErrorResponse(error);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100dvh',
        gap: 2,
        p: 4,
      }}
    >
      <Typography variant="h1" sx={{ fontSize: '3rem' }}>
        {isRoute ? error.status : 'Error'}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {isRoute ? error.statusText : 'Something went wrong.'}
      </Typography>
      <Button variant="contained" onClick={() => window.location.assign('/')}>
        Back to home
      </Button>
    </Box>
  );
}
